<template>
  <div class="padding">
    <div class="singlework container">
      <section class="work-content">
        <h1>{{ workTitle }}</h1>
        <p>
          {{ workPara }}
        </p>
        <div class="highlights">
          <div class="highlight-item">
            <h6>Company</h6>
            <h5>{{ companyName }}</h5>
          </div>
          <div class="highlight-item">
            <h6>Year</h6>
            <h5>{{ yearName }}</h5>
          </div>
          <div class="highlight-item">
            <h6>Project</h6>
            <h5>{{ projectType }}</h5>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ["workTitle", "workPara", "companyName", "yearName", "projectType"],
};
</script>
